import { render, staticRenderFns } from "./PasswordProtectedForm.vue?vue&type=template&id=f1b6a4ac"
import script from "./PasswordProtectedForm.vue?vue&type=script&lang=js"
export * from "./PasswordProtectedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports